import axios from 'axios'
import {appConst} from '@/lib/consts'
import Vue from 'vue'
import {responseHelper} from "./utils/response-helper";
export const $http = axios.create({
    baseURL: appConst.remoteServiceBaseUrl,
    timeout: 30000
});
$http.interceptors.request.use(function (config) {
    if(!!window.basic.utils.getToken()){
        config.headers.common["Authorization"]="Bearer "+window.basic.utils.getToken();
    }
    config.headers.common[".AspNetCore.Culture"]=window.basic.utils.getCookieValue("Localization.CultureName");
    config.headers.common["Abp.TenantId"]=window.basic.utils.getTenantIdCookie();
    return config;
  }, function (error) {
    
    return Promise.reject(error);
});
let vm=new Vue({});
$http.interceptors.response.use((respon)=>{    
    return respon
},(error)=>{
    responseHelper.handleError(vm, error);
    setTimeout(()=>{
       vm.$Message.destroy();
    },1000);
    return Promise.reject(error);
});